import React from 'react'
import useSmartviewManager from './use-smartview-manager'

export default function useSmartviewMounter (smartview, replace = true, keepTreeOnPush = false) {
  const smartviewManager = useSmartviewManager()

  return (props = {}) => {
    if (replace) {
      return smartviewManager.mount(smartview, props)
    }

    return smartviewManager.push(smartview, props, keepTreeOnPush)
  }
}
